function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 3,
  width: 16,
  height: 16,
  rx: 8,
  fill: "#7434FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.49088 7.35446C7.66577 6.88185 8.33423 6.88184 8.50912 7.35446L9.26961 9.40966C9.32459 9.55825 9.44175 9.67541 9.59034 9.73039L11.6455 10.4909C12.1182 10.6658 12.1182 11.3342 11.6455 11.5091L9.59034 12.2696C9.44175 12.3246 9.32459 12.4417 9.26961 12.5903L8.50912 14.6455C8.33423 15.1182 7.66577 15.1182 7.49088 14.6455L6.73039 12.5903C6.67541 12.4417 6.55825 12.3246 6.40966 12.2696L4.35446 11.5091C3.88185 11.3342 3.88184 10.6658 4.35446 10.4909L6.40966 9.73039C6.55825 9.67541 6.67541 9.55825 6.73039 9.40966L7.49088 7.35446Z",
  fill: "white"
});

function SvgListStyleStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListStyleStar);
export default __webpack_public_path__ + "static/media/list-style-star.1e055490.svg";
export { ForwardRef as ReactComponent };